import React, { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle, IconButton, SxProps } from '@mui/material';
import { SnackbarContent, CustomContentProps } from 'notistack';

import ToastVariant from '../enums/ToastVariant';
import palette from '../theme/palette';

interface NotificationToastProps {
  caption: ReactNode;
  cta?: {
    onClick: () => void;
    label?: ReactNode;
  };
  variant: ToastVariant;
  title?: ReactNode;
  sx?: SxProps;
}

interface ToastCompleteProps extends CustomContentProps {
  customProps: NotificationToastProps;
}

declare module 'notistack' {
  interface VariantOverrides {
    custom: {
      customProps: NotificationToastProps;
    };
  }
}

const SnackBar = React.forwardRef<HTMLDivElement, ToastCompleteProps>((props, ref) => {
  const { cta, variant, title, caption, sx } = props.customProps;
  return (
    <SnackbarContent ref={ref}>
      <Alert
        icon={false}
        sx={{
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: 3,
          ...sx
        }}
        severity={variant}
        // onClose={() => closeSnackbar()}
        action={
          cta && (
            <IconButton onClick={cta.onClick}>
              <CloseIcon sx={{ color: palette.white, width: '14px', height: '14px' }} />
            </IconButton>
          )
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {caption}
      </Alert>
    </SnackbarContent>
  );
});

SnackBar.displayName = 'SnackBar';

export default SnackBar;
